<template>
  <div class="wrap">
    <div class="inner-box">
      <div>
        <el-button @click="allSubject" type="success" size="medium">食堂汇总</el-button>
        <el-button @click="unbound" type="primary" size="medium" style="margin-left: 10px;">待绑定</el-button>
        <el-button @click="hasBound" type="primary" size="medium" style="margin-left: 10px;">已绑定</el-button>
      </div>
      <div class="mt20">
        <el-input placeholder="食堂名称" class="w350 seekIpt" v-model="searchInput" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
        <el-cascader class="ml20 w300" v-model="areaCode" :options="areaList.options" @change="areaChange"
                     :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
        <el-select class="ml20 w120" v-model="isBind" @change="bindChange" clearable placeholder="绑定状态">
          <el-option v-for="item in isBindKeyValue" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin-top: 10px;">
        <el-table :data="tableData" border style="width: calc(100% - 10px);" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
          <el-table-column label="序号" width="60" type=index >
            <template slot-scope="scope">
              {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="schoolname" label="省平台学校名称" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.schoolname ? scope.row.schoolname: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="dname" label="省平台食堂名称" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.dname ? scope.row.dname: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="prAreaName" label="对接区域" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.prAreaName ? scope.row.prAreaName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="entityName" label="主体名称" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.entityName ? scope.row.entityName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="areaName" label="主体行政区" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.areaName ? scope.row.areaName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="isSubEntity" label="是否子食堂" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.isSubEntity ? scope.row.isSubEntity: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="subEntityName" label="子食堂名称" min-width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.subEntityName ? scope.row.subEntityName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="isBind" label="是否绑定" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.isBind ? scope.row.isBind: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="bindTime" label="绑定时间" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.bindTime ? scope.row.bindTime: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.createTime ? scope.row.createTime: '-'}}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isBind === '已绑定'" @click="toUnbind(scope.row)" type="warning" plain size="small">解绑</el-button>
              <el-button v-if="scope.row.isBind === '未绑定'" @click="toBind(scope.row)" type="primary" plain size="small">绑定</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px; margin-right:10px"></ybPagination>
      <pro-dinning-room-dialog v-if="diningRoomDialogVisible" :dinningRoomData="dinningRoomData" :diningRoomDialogVisible="diningRoomDialogVisible" @closeDinningRoomDialog="closeDinningDialogVisible"></pro-dinning-room-dialog>

    </div>
  </div>
</template>
<script>

import * as subManageApi from '@/api/subManage'
import * as prConnectApi from '@/api/prConnectprovincial'
import ybPagination from '@/components/ybPagination'
import * as mapping from '@/utils/enumList'
import ProDinningRoomDialog from "views/province/ProDinningRoomDialog";
export default {
  name: 'diningRoomList',
  components: {
    ProDinningRoomDialog,
    ybPagination
  },
  data() {
    return {
      searchInput: '',
      parentId: '0',
      areaId:'',
      areaCode:'',
      isBindKeyValue: mapping.getKeyVal('prBindType'),
      isBind: '',
      tableLoading: false,
      tableData: [],
      areaList: {
        selOptions: [],
        options: [],
        parentCode: '',
        props: {
          checkStrictly: true,
          expandTrigger: 'hover',
          value: 'areaId',
          label: 'areaName',
          children: 'children',
          lazy: true,
          lazyLoad(node, resolve) {}
        }
      },
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 10
      },
      dinningRoomData: {
        did: '',
        prAreaId: ''
      },
      diningRoomDialogVisible: false
    }
  },
  computed: {
    params: function() {
      return {
        current: this.page.pageNum,
        keyword: this.searchInput,
        areaId: this.areaId,
        size: this.page.pageSize,
        isBind: this.isBind
      }
    }
  },
  methods: {
    // '主体汇总'按钮
    allSubject() {
      this.searchInput = ''
      this.areaId = ''
      this.areaCode = ''
      this.areaList.selectedOptions = ''
      this.isBind = ''
      this.page.pageNum = 1
      this.tableRefresh()
    },
    // '待绑定'按钮
    unbound() {
      this.isBind = '0'
      this.page.pageNum = 1
      this.tableRefresh()
    },
    // '已绑定'按钮
    hasBound() {
      this.isBind = '1'
      this.page.pageNum = 1
      this.tableRefresh()
    },
    // 搜索
    search() {
      this.page.pageNum = 1
      this.tableRefresh()
    },
    // 点击区域节点前的圆圈进行选择
    areaChange(val) {
      this.page.pageNum = 1
      if(val==undefined){
        val = [];
      }
      this.areaList.selectedOptions = val;
      this.areaId = this.areaList.selectedOptions[this.areaList.selectedOptions.length-1]
      this.tableRefresh();
    },
    // 绑定状态筛选
    bindChange(value) {
      this.page.pageNum = 1
      this.tableRefresh()
    },
    tableRefresh() {
      this.tableLoading = true
      prConnectApi.getDinningRoom(this.params).then(r => {
        if(r.code === 200) {
          let data = r.data.records
          data.forEach(el => {
            el.isSubEntity = mapping.keyToVal('isSubEntity', el.isSubEntity)
            el.isBind = mapping.keyToVal('prBindType', el.isBind)
          })
          this.tableData = data
          this.page.total = parseInt(r.data.total)
        }
        this.tableLoading = false;
      }).catch(err => {})
    },
    // 绑定
    toBind(row) {
      this.dinningRoomData.did = row.did;
      this.dinningRoomData.prAreaId = row.prAreaId;
      this.diningRoomDialogVisible = true;
    },
    // 解绑
    toUnbind(row) {
      this.$confirm('确认要将食堂解除绑定吗？！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        prConnectApi.unBindDiningRoom({id: row.did}).then(r => {
          if(r.code === 200) {
            this.$message.success('解绑成功')
            this.tableRefresh()
          }
        }).catch(err => {})
      }).catch(e => {});
    },
    // 关闭食堂弹窗
    closeDinningDialogVisible() {
      this.diningRoomDialogVisible = false;
    },
    // 页数改变
    pageCurrentChange(num) {
      if(num !== this.page.pageNum) {
        this.page.pageNum = num;
        this.tableRefresh();
      }
    },
    // 页数据量改变
    pageSizeChange(size) {
      if(size !== this.page.pageSize) {
        this.page.pageSize = size;
        this.tableRefresh();
      }
    }
  },
  created() {
    let that = this;
    that.areaList.props.lazyLoad = function (node, resolve) {
      let code = node.value ? node.value : that.parentId;
      if (code.length > 6) {
        return resolve([])
      }
      subManageApi.getAreaList({
        parentId: code
      }).then(r => {
        if (r.code === 200) {
          resolve(r.data)
        }
      });
    }
    this.tableRefresh();
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: calc(100% - 40px);
  text-align: left;
}
</style>
